import utils from '@/js/utils';
import CryptoJS from 'crypto-js';
export var globalMixin = {
  data: function data() {
    return {};
  },
  methods: {
    objectIsEqual: function objectIsEqual(object1, object2) {
      return utils.deepEqual(object1, object2);
    },
    stringToHash: function stringToHash(str) {
      var hash = CryptoJS.SHA256(str);
      var hex = hash.toString(CryptoJS.enc.Hex);
      return hex;
    },
    getmenu: function getmenu(texto) {
      var matriz = texto.split('.');
      return matriz[matriz.length - 1];
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    }
  },
  computed: {}
};